import { render } from "./F2Toolbar.vue?vue&type=template&id=31f0f9fc&scoped=true&ts=true"
import script from "./F2Toolbar.vue?vue&type=script&lang=ts"
export * from "./F2Toolbar.vue?vue&type=script&lang=ts"

import "./F2Toolbar.vue?vue&type=style&index=0&id=31f0f9fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f0f9fc"]])

export default __exports__